module.exports = __webpack_public_path__ + "img/zhongbang.30d49756.png";